(function () {
    "use strict";

    angular.module("cardspotWeb")
        .config(configModule);

    configModule.$inject = ["$provide"];

    function configModule($provide) {
        $provide.decorator("navigate", decorateNavigateService);
    }

    decorateNavigateService.$inject = ["$delegate", "NAV_URLS", "HVT_REQUEST_TYPES"];

    function decorateNavigateService($delegate, NAV_URLS, HVT_REQUEST_TYPES) {

        $delegate.toEnterSales = function (isOrganization) {
            if (isOrganization) {
                $delegate.to(NAV_URLS.ENTER_SALES_COMPANY);
            } else {
                $delegate.to(NAV_URLS.ENTER_SALES_INDIVIDUAL);
            }
        };
        
        $delegate.toHome = function (referrer) {
            $delegate.setReferrer(referrer);
            $delegate.to(NAV_URLS.HOME);
        };

        $delegate.toLogin = function (referrer) {
            $delegate.setReferrer(referrer);
            $delegate.to(NAV_URLS.LOGIN);
        };

        $delegate.toReauthenticate = function (referrer, userName) {
            $delegate.setReferrer(referrer);
            $delegate.to(NAV_URLS.LOGIN + "/" + userName);
        };

        $delegate.toConfirmSignage = function (referrer) {
            $delegate.setReferrer(referrer);
            $delegate.to(NAV_URLS.CONFIRM_SIGNAGE);
        };

        $delegate.toApplicationConfiguration = function (referrer) {
            $delegate.setReferrer(referrer);
            $delegate.to(NAV_URLS.APPLICATION_CONFIGURATION);
        };

        $delegate.toLookupSales = function () {
            $delegate.to(NAV_URLS.LOOKUP_SALES);
        };

        $delegate.toLookupCard = function () {
            $delegate.to(NAV_URLS.LOOKUP_CARD);
        };

        $delegate.toLookupCustomer = function () {
            $delegate.to(NAV_URLS.LOOKUP_CUSTOMER);
        }

        $delegate.toViewActivationDetails = function (id) {
            $delegate.to(NAV_URLS.LOOKUP_SALES + "/" + id);
        };
        
        $delegate.toTransferCard = function () {
            $delegate.to(NAV_URLS.TRANSFER_CARD);
        };

        $delegate.toOnlineResources = function () {
            $delegate.to(NAV_URLS.ONLINE_RESOURCES);
        }

        $delegate.toHvtRequest = function (type) {
            if (type === HVT_REQUEST_TYPES.CONSUMER)
                $delegate.to(NAV_URLS.HVT_REQUEST_CONSUMER);
            else if (type === HVT_REQUEST_TYPES.CORPORATE)
                $delegate.to(NAV_URLS.HVT_REQUEST_CORPORATE);
        }

        $delegate.setDefaultUrl();

        return $delegate;
    }

}());